<template>
    <mdb-container fluid>
        <div class="justify-content-md-center" style="
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            height: 100vh;
            display: flex;
            flex-direction: column;
            align-items: center;
            background: rgba(0,0,0,0.5);
            z-index: 100;">
            <div style="width: 100px;height: 100px;border-color: black;" class="spinner-border"></div>
            <div style="margin-top: 10px;">Loading....</div>
        </div>        
  </mdb-container>
</template>
<script>
import { mdbContainer } from 'mdbvue';
export default {
    name: 'Body',
    data(){
        return{
        }
    },
    components:{
        mdbContainer
    },
    created(){        
         this.logMeOut();
    },
    mounted(){
    },
    methods:{
        logMeOut(){
            var filename=localStorage.filename;
            var id_eap=localStorage.id_eap;
            localStorage.removeItem('id_session');
            localStorage.removeItem('id_company');            
            localStorage.clear();
            if(filename!=""){
                window.location.assign('/companyLogin/'+id_eap+'/'+filename);
            }
            else{
                this.$router.go('/');
            }
        }
    }
 
};
</script>
